import { type FC, useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useLoadBlockGames } from '@mwl/core-lib';
import { Loader } from '@/components/Loader/Loader';
import { SectionGames } from '@/components/SectionGames/SectionGames';
import { casinoCardsBreakpoints, gameAnalytics } from '@/constants';
import { loadCasinoTopBlockGames } from '../../utils/loadGames';
import { initialState } from '../constants';
import styles from '../common.module.scss';
export const CasinoTopGamesPage: FC = () => {
  const {
    t
  } = useTranslation('casino');
  const [state, setState] = useState(initialState);
  const handleLoaded = useCallback(() => setState(prev => ({
    ...prev,
    isLoading: false
  })), []);
  const {
    items: games
  } = useLoadBlockGames({
    loadMethod: loadCasinoTopBlockGames,
    onLoadFinished: handleLoaded
  });
  return <div className={styles.root} data-sentry-component="CasinoTopGamesPage" data-sentry-source-file="CasinoTopGamesPage.tsx">
      {state.isLoading && <div className={styles.loader}>
          <Loader />
        </div>}
      <SectionGames games={games} isInfinite breakpoints={casinoCardsBreakpoints} className={styles.section} title={t('section.top_games_casino', 'Top')} analytics={gameAnalytics} data-sentry-element="SectionGames" data-sentry-source-file="CasinoTopGamesPage.tsx" />
    </div>;
};